module.exports = __webpack_public_path__ + "static/media/BenjaminBusfield.a060acdb.png";